<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "KD3",
  data() {
    return {};
  },
  methods: {},
};
</script>

<style>
@import "../../assets/hkapp.css";
</style>
